import * as Yup from 'yup';

export const NewLogSchema = Yup.object().shape({
  logTypeId: Yup.string().required('Required'),
  description: Yup.string().required('Required'),
  document: Yup.string().nullable(),
  date: Yup.date(),
  logForAll: Yup.boolean().required('Required'),
});

export interface INewLog {
  logTypeId: string;
  description: string;
  document?: string; // TODO
  date?: string;
  logForAll: boolean;
}
